import { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

export const modalCss = {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1,
    outline: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    background: 'rgba(0, 0, 0, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

export default class Modal extends Component {
    constructor(props) {
        super(props);

        this.modalRoot = document.getElementById('modal-root');
        this.el = document.createElement('div');
    }

    componentDidMount() {
        this.modalRoot.appendChild(this.el);
    }

    componentWillUnmount() {
        this.modalRoot.removeChild(this.el);
    }

    render() {
        return ReactDOM.createPortal(this.props.children, this.el);
    }
}

Modal.propTypes = { children: PropTypes.node };
